import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/asignadorFuncion/importer/asignadorFuncionImporterSelectors';
import AsignadorFuncionService from 'src/modules/asignadorFuncion/asignadorFuncionService';
import fields from 'src/modules/asignadorFuncion/importer/asignadorFuncionImporterFields';
import { i18n } from 'src/i18n';

const asignadorFuncionImporterActions = importerActions(
  'ASIGNADORFUNCION_IMPORTER',
  selectors,
  AsignadorFuncionService.import,
  fields,
  i18n('entities.asignadorFuncion.importer.fileName'),
);

export default asignadorFuncionImporterActions;